<section class="sidebar"
    [ngClass]="{small: isSmallScreen, open: isMenuOpen}">
    <img class="menu-btn" 
        (click)="toggleMenu()" 
        src="../assets/icons/menu.svg" 
        alt="Menu button" />
    <nav-header></nav-header>
    <navigation (onClick)="toggleMenu()"></navigation>
    <nav-footer></nav-footer>
</section>